<template>
  <!--添加问卷  -->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="AddList"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="活动名称" prop="activityName">
              <el-input
                placeholder="请输入内容"
                v-model="AddList.activityName"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否轮播" prop="isRotation">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="AddList.isRotation"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in newsStatus"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="活动时间" prop="value1">
              <el-date-picker
                clearable
                end-placeholder="活动结束日"
                range-separator="至"
                size="small"
                start-placeholder="活动起始日"
                type="daterange"
                v-model="AddList.value1"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="活动介绍" prop="introduce">
              <el-input
                type="textarea"
                :rows="10"
                placeholder="请输入内容"
                v-model="AddList.introduce"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="封面图" prop="coverUrl" ref="coverUrl">
            <el-upload
              class="avatar-uploader"
              :action="serverUrl"
              :headers="header"
              name="img"
              :auto-upload="true"
              :show-file-list="false"
              :on-success="upSuccess"
            >
              <img
                v-if="AddList.coverUrl"
                :src="AddList.coverUrl"
                class="avatar"
              />

              <i
                :class="
                  loadUpt
                    ? 'el-icon-loading'
                    : 'el-icon-plus avatar-uploader-icon'
                "
                style="margintop: 10px; font-size: 50px"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd('ruleForm')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证

      if (this.AddList.coverUrl == "") {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };
    return {
      loadUpt: false,
      myHeaders: { token: this.$store.state.token },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      imgLoad: false, //加载load
      newsStatus: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      AudioUptImg: [], //图片上传
      //添加的参数：
      AddList: {
        activityName: "", //专辑名字
        introduce: "", //描述
        coverUrl: "", //封面图
        isRotation: "", //是否轮播
        value1: "", //活动时间
      },
      toAdRule: {
        isRotation: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        activityName: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        introduce: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        value1: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        coverUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
      },
    };
  },
  methods: {
    upSuccess(file) {
      this.AddList.coverUrl = file.entity;
      if (file.entity) {
        this.$refs.coverUrl.clearValidate();
      }
    },
    //提交成功：
    TopicSuccess(res, file) {
      this.$refs.uptImg.clearValidate();
    },
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/wenjuan/insert", {
            activityName: this.AddList.activityName, //活动名称
            introduce: this.AddList.introduce, //活动介绍
            startDate: this.AddList.value1[0], //开始时间
            endDate: this.AddList.value1[1], //结束时间
            coverUrl: this.AddList.coverUrl, //封面图
            isRotation: this.AddList.isRotation, //是否轮播
          }).then((res) => {
            if (res.success == true) {
              this.$router.push("/wj");
              this.$message.success("添加成功！");
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {},
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /deep/ .el-upload {
      width: 200px;
      height: auto;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      outline: 0;
      border: 2px dashed #eee;
      display: table-cell;
      vertical-align: middle;
      text-align: center;

      img {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }

    /deep/ .el-upload-list--picture-card {
      margin: 0;
      display: inline;
      vertical-align: top;
      // display: table-cell;
      vertical-align: middle;
      text-align: center;
    }
  }
}
</style>